module.exports = __webpack_public_path__ + "static/images/bg-two.296a4f0.png";